import React, { useState } from "react";
import { Button, Card, Nav, Badge } from "react-bootstrap";
import Letter from "./Letter";
import NavBar from "./NavBar";

const Mail = (props) => {
  const [letter, setLetter] = useState(false);
  function toggleLetter() {
    if (letter) {
      setLetter(false);
    } else {
      setLetter(true);
    }
  }
  if (letter) {
    return (
      <div>
        <h3 className="input">
          Dear {props.receiver},
          <br />
          {props.text}
          <h3 align="right">
            Sincerely,
            <br />
            {props.sender}
          </h3>
          <button onClick={toggleLetter} className="edit-btn">
            Close
          </button>
        </h3>
      </div>
    );
  } else {
    return (
      <a onClick={toggleLetter}>
        <img className="object-none h-25 w-25" src={props.img} alt="bottle" />
      </a>
    );
  }
};

export default Mail;
